import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cpfCnpj'
})
export class CpfCnpjPipe implements PipeTransform {

  transform(value: string | number | null | undefined): string {
    if (value == null) {
      return '-';
    }

    const formattedValue = value.toString();
    if (formattedValue.length === 11) {
      // CPF format: 123.456.789-00
      return formattedValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (formattedValue.length === 14) {
      // CNPJ format: 12.345.678/0001-00
      return formattedValue.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([0-9]{2})$/,'$1.$2.$3/$4-$5');
    }
    return formattedValue;
  }

}
